(function (angular) {
	angular.module('bizPartEngage').directive('bizFavorite', bizFavorite);
	angular.module('bizPartEngage').directive('bizFavoriteList', bizFavoriteList);
	angular.module('bizPartEngage').directive('bizFavoriteEditList', bizFavoriteEditList);

	bizFavorite.$inject = ['bizCore'];
	bizFavoriteList.$inject = ['bizCore'];
	bizFavoriteEditList.$inject = ['bizCore'];

	function bizFavorite(bizCore) {
		var directive = {
			restrict: 'E',
			scope: {
				objectType: '@',
				objectId: '@',
				label: '@',
				favorite: '=?',
			},
			templateUrl: bizCore.getView('core.directives.favorite', 'FrontEnd/Core/Directives/Views/Favorite.html'),
			bindToController: true,
			controller: bizFavoriteController,
			controllerAs: 'vm',
		};

		bizFavoriteController.$inject = ['core.services.favorite', '$rootScope'];

		function bizFavoriteController(favoriteService, $rootScope) {
			var vm = this;

			vm.Init = Init;
			vm.ToggleFavorite = ToggleFavorite;

			function ToggleFavorite() {
				vm.favorite = !vm.favorite;

				if (vm.favorite) favoriteService.AddFavorite(vm.objectType, vm.objectId).then(FavoriteChangeCallback);
				else favoriteService.RemoveFavorite(vm.objectType, vm.objectId).then(FavoriteChangeCallback);

				function FavoriteChangeCallback() {
					favoriteService.GetFavorites(false).then(function (response) {
						$rootScope.$broadcast('favorites.change', response.data);
					});
				}
			}

			function Init() {
				if (vm.favorite !== undefined) return;

				if ($rootScope.FavMarkedCssClass === undefined)
					$rootScope.FavMarkedCssClass = 'fa-solid fa-heart biz-primary-icon';

				if ($rootScope.FavUnmarkedCssClass === undefined) $rootScope.FavUnmarkedCssClass = 'fa-regular fa-heart';

				favoriteService.IsFavorite(vm.objectType, vm.objectId).then(IsFavoriteCallback);

				function IsFavoriteCallback(response) {
					vm.favorite = !!response.data;
				}
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}

	function bizFavoriteList(bizCore) {
		var directive = {
			restrict: 'E',
			scope: {
				objectType: '@',
				favorites: '=?',
			},
			templateUrl: bizCore.getView('core.directives.favoritelist', 'FrontEnd/Core/Directives/Views/FavoriteList.html'),
			bindToController: true,
			controller: bizFavoriteListController,
			controllerAs: 'vm',
		};

		bizFavoriteListController.$inject = ['core.services.favorite'];

		function bizFavoriteListController(favoriteService) {
			var vm = this;

			vm.Init = Init;
			vm.RemoveFavorite = RemoveFavorite;

			function RemoveFavorite(favorite) {
				favoriteService.RemoveFavorite(favorite.ObjectType, favorite.ObjectId);
				vm.favorites.Remove(favorite);
			}

			function Init() {
				if (vm.favorites) return;

				if ($rootScope.FavMarkedCssClass === undefined)
					$rootScope.FavMarkedCssClass = 'fa-solid fa-heart biz-primary-icon';

				if ($rootScope.FavUnmarkedCssClass === undefined) $rootScope.FavUnmarkedCssClass = 'fa-regular fa-heart';

				favoriteService.GetFavorites(false, vm.objectType).then(GetFavoritesCallback);

				function GetFavoritesCallback(response) {
					vm.favorites = response.data;
				}
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}

	function bizFavoriteEditList(bizCore) {
		var directive = {
			restrict: 'E',
			scope: {},
			templateUrl: bizCore.getView('core.directives.favoritelist', 'FrontEnd/Core/Directives/Views/FavoriteEditList.html'),
			bindToController: true,
			controller: bizFavoriteEditListController,
			controllerAs: 'vm',
		};

		bizFavoriteEditListController.$inject = ['core.services.favorite', 'bizCoreService', '$rootScope'];

		function bizFavoriteEditListController(favoriteService, bizCoreService, $rootScope) {
			var vm = this;
			vm.Tags = [];
			vm.Init = Init;

			function Init() {
				bizCoreService.GetAllTags($rootScope.LoggedInUser.CurrentCultureId).then(GetTagsCallback);

				function GetTagsCallback(response) {
					vm.Tags = response.data;
				}

				// if (vm.favorites) return;

				// favoriteService.GetFavorites(false, vm.objectType).then(GetFavoritesCallback);

				// function GetFavoritesCallback(response) {
				// 	vm.favorites = response.data;
				// }
			}

			$rootScope.Initialized.then(vm.Init);

			//vm.$onInit = vm.Init;
		}

		return directive;
	}
})(window.angular);
